<template>
  <el-dialog :title="mytitle" :visible.sync="dialogFormVisible" custom-class="full-dialog" center :append-to-body="true"
             :close-on-click-modal="false" @close="onDialogClose"
  >
    <div class="search-content write-order">
      <el-row>
        <el-row >
          <el-col :span="24" class="toobar">
            <el-col :span="5">
              <AutoCustomer ref="autocustomer" @handleSelect="select" :splitByAddress="true"  :needfocus="true" @clear="clearcustomerserial"></AutoCustomer>
            </el-col>
            <!--<div style="float: right;width: 1411px;">-->
            <el-col :span="18">
              <el-select v-model="cangkucode" @change="changeCangKu" v-if="customerserial"  style="width: 130px;display: block;margin: auto;float: left;margin-left: 30px;">
                <el-option v-for="item in jxcstoreData" :key="item.cangkucode"
                           :label="item.cangkuname"
                           :value="item.cangkucode"
                >
                </el-option>
              </el-select>
              <CommonTree ref="treeSeed" :defineDataSource="true" @bindData="bindData"
                          :isShowCheckBox="false" :treeWidth="550"
                          v-show="!scanmode"
                          style="width: 200px;display: block;margin: auto;float: left;margin-left: 30px;"
                          :treeHeight="500" :searchText="seedname"
                          @check="checktree1"></CommonTree>
              <el-input v-model="tracknum" ref="tracknum" placeholder="请填写供应商单号" @change="tracknumsubmit" clearable
                        onfocus="this.select()"
                        style="width: 160px"></el-input>
              <el-input v-model="logisticstracknum" ref="logisticstracknum" placeholder="请填写跟踪单号" clearable
                        onfocus="this.select()"
                        @change="logisticstracknumsubmit"
                        style="width: 160px"></el-input>
            </el-col>
            <!--</div>-->
          </el-col>
        </el-row>
        <el-row v-if="false">
          <div style="float: left;margin-top: 8px;font-size: larger;margin-left: 5px"
               v-if="deliveryaddress==''?false:true"> 门店：<span>{{this.deptname}}</span>&nbsp;&nbsp;收货地址：<span>{{this.deliveryaddress}}</span>
          </div>
        </el-row>
      </el-row>
      <el-row v-show="!showframe && !scanmode">
        <el-col :span="24">
          <el-tag v-for="item in pingpaiLens" style="margin-right: 6px;cursor: pointer;margin-bottom: 3px" :class="item.type=='danger'?'el-tag--danger':'el-tag--info'"
                    :key="item.categorycode" @click="selectLens(item.categorycode)">{{item.categoryname}}</el-tag>
        </el-col>
        <el-col :span="6">
          <el-card class="box-card" style="width: 98%">
          <el-form :model="form" ref="form1" label-width="70px" size="mini">
          <el-form-item label="系列">
            <el-select v-model="form.category" placeholder="请选择" @change="showTable">
              <el-option label="" value=""></el-option>
              <el-option v-for="x in xilieLens"
                         :key="x.categorycode"
                         :label="x.categoryname"
                         :value="x.categorycode">
              </el-option>
            </el-select>
          </el-form-item>
            <el-form-item label="编码" >
              <el-input v-model="form.code" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item label="名称">
              <el-input v-model="form.name" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item v-for="(item,index) in queryproperty" :label="item.name" :key="index">
              <div v-if="item.items.length>1&&(item.name=='折射率'||item.items.length<=6)">
                <el-tag style="margin-right: 6px;cursor: pointer;margin-bottom: 3px"
                        :class="''==item.value?'el-tag--danger':'el-tag--info'"  @click="selectQuery(item,'')">&nbsp;</el-tag>
              <el-tag v-for="(o,oindex) in item.items" style="margin-right: 6px;cursor: pointer;margin-bottom: 3px"
                      :class="o==item.value?'el-tag--danger':'el-tag--info'"
                      :key="oindex" @click="selectQuery(item,o)" v-if="o">{{o}}</el-tag>
              </div>
              <el-select v-else v-model="item.value" placeholder="请选择" @change="showTable">
                <el-option label="" value=""></el-option>
                <el-option v-for="x in item.items"
                           :key="x" :label="x" :value="x">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          </el-card>
        </el-col>
        <el-col :span="12">
          <el-table
            :data="goodsLens.filter(data =>data.isshow&&
            (!form.code || data.seedcode.toLowerCase().includes(form.code.toLowerCase()))&&
            (!form.name || data.seedname.includes(form.name)))"
            :height="tableHeight(170)"
            size="mini"
            stripe
            border
            style="width: 100%;">
            <!--<el-table-column fixed-->
                             <!--width="60"-->
                             <!--label="序号"-->
                             <!--align="center">-->
              <!--<template slot-scope="scope">-->
                <!--{{1+scope.$index}}-->
              <!--</template>-->
            <!--</el-table-column>-->
            <el-table-column
                             prop="seedname" :show-overflow-tooltip="true"
                             label="名称" width="350"
                             align="left"
                             header-align="center">
            </el-table-column>
            <el-table-column
              prop="seedcode"
              label="编码" :show-overflow-tooltip="true"
              align="left"
              header-align="center"
              width="190">
            </el-table-column>
            <el-table-column fixed="right"
                             label="操作"
                             align="center" width="80">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="checkTable(scope.row)">选择
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="6">
          <el-table
            :data="shoppingLens"
            size="mini"
            stripe
            border
            style="width: 100%;">
            <el-table-column
                             prop="seedname"
                             label="购物车"
                             align="left"
                             header-align="center">
            </el-table-column>
            <el-table-column
              prop="number"
              label="数量"
              align="left"
              header-align="center"
              width="50">
            </el-table-column>
            <el-table-column
                             label=""
                             align="center" width="40">
              <template slot-scope="scope">
                <i class="el-icon-delete" style="cursor: pointer" @click="removeShopp(scope.row)"></i>
              </template>
            </el-table-column>
          </el-table>
          <el-button type="primary" @click="cangKuGoodsUpdate()" v-if="shoppingLens.length>0" :loading="btnupdatevisible" size="mini" style="margin-right: 10px;float: right">生成多个退货单</el-button>
          <el-button type="success" @click="cangKuGoodsUpdateMerge()" v-if="shoppingLens.length>0" :loading="btnupdatevisible" size="mini" style="margin-right: 50px;float: right">合并一个退货单</el-button>
        </el-col>
      </el-row>
      <el-row v-show="showframe && !scanmode">
        <el-col :span="24">
          <iframe width=100% scrolling="Auto" id="iframe" ref="iframe"
                  :height="tableHeight(105)" frameborder="0" name="writeorder" @click="isshow"></iframe>
        </el-col>
      </el-row>
      <el-row v-if="scanmode && showframe">
        <el-col :span="24">
          <HsScanlensReturn ref="HsScanlensReturnComp"
            :style="{height: tableHeight(105) + 'px'}"></HsScanlensReturn>
        </el-col>
      </el-row>
    </div>
    <HsCstagreementList ref="HsCstagreementList"></HsCstagreementList>
  </el-dialog>
</template>
<script>

  import {getListData, deleteData} from '@/api/set/externaldept';
  import {independentDept} from '@/api/set/dept';
  import {simulationLogin,checkModuleRight} from '@/api/login';
  import {cusandptbyind} from '@/api/set/jxcstore';
  import HsCstagreementList from './HsCstagreementList';
  import HsScanlensReturn from './HsScanlensReturn';
  import {getGoodsTree,getListfixcilumn} from '@/api/set/jxcgooddetail';
  import {listLens,getListData as categoryList} from '@/api/set/jxcgoodscategory';

  export default {
    inject: ["afterCloseDialog"],
    name: 'WriteReturnOrder',
    data() {
      return {
        openURL: 'HsTuiHuoXianPianApp',
        showframe:false,
        activeIndex: '1',
        msg: 'Welcome to Your Vue.js App',
        dialogFormVisible: false,
        form:{
          code:'',
          name:'',
          category:'',
          query:'',
        },
        btnupdatevisible:false,
        searchdata: "",
        fengongscangku:false,
        myunitgroup: this.unitgroup,
        mytitle: this.title,
        loading: true,
        tableData: [],
        pinyinData: [],
        pingpaiLens:[],
        xilieLens:[],
        goodsLens:[],
        shoppingLens:[],
        queryproperty:[],
        coupon: '',
        province: '',//省
        city: '',//市
        county: '',//县
        couponServedserial: '',//独立核算
        deliveryaddress: '',//收货地址
        deptname: '',
        loginName: '',
        customerserial: '',
        restaurants: [],
        timeout: null,
        elinkman: '',
        elinkmantel: '',
        canshowgoodsel: true,//解决清空事件与click的冲突问题
        seedcode: '',
        seedname: '',
        jxcstoreData: [],//仓库数组
        cangkucode: '',//选中的仓库
        cangkuname: '',
        roletype: '',//岗位类型
        tracknum: '',//供应商单号
        logisticstracknum: '',//跟踪单号
        myToken: '',//选中客户后记录的 token（多窗口防串客户：检测到 token 变了就关闭开单窗口）
        sessionCheckTimer: null,//防串客户轮询定时器（关闭对话框时注销）
        scanmode: false,//是否处于扫光度码退货模式
      }
    },
    props: {
      unitgroup: {
        default: 1
      },
      title: {
        default: "客户信息"
      },
      parentcustomerserial: {//上级客户编码
        default: ""
      },
      filterbyservedserial: {//根据当前登录人所属的加工中心过滤数据
        default: false
      },
      storeInfo: {
        default: ""
      }
    },
    methods: {
      removeShopp(row) {
        var sl = JSON.parse(localStorage.getItem("tuihuoShopping"));
        for (let i in sl) {
          if (sl[i].unitguid == row.unitguid) {
            sl.splice(i, 1);
            break;
          }
        }
        localStorage.setItem("tuihuoShopping",JSON.stringify(sl))
        this.setShopping();
      },
      //iframe 子类调用的方法（退货成功后用）
      setShopping(){
        this.shoppingLens=[]
        this.btnupdatevisible=false;
        var s = localStorage.getItem("tuihuoShopping");
        if(s) {
          var sl= JSON.parse(s);
          for (let i in sl) {
            if (sl[i].customerserial == this.customerserial)
              this.shoppingLens.push(sl[i])
          }
        }
      },
      isshow() {
        if (window.localStorage.getItem('THcloseIframe') == '-1') {//只是关闭选择商品的页面
          this.showframe = false;
          this.setShopping();
        } else {
          this.dialogFormVisible = false
          this.$emit("bindGrid")//刷新页面
        }
      },
      tracknumsubmit() {
        localStorage.setItem('tracknum', this.tracknum.trim());
        this.$refs.logisticstracknum.focus()
      },
      logisticstracknumsubmit() {
        localStorage.setItem('logisticstracknum', this.logisticstracknum.trim());
      },
      //商品选择后执行的方法
      checktree1(guids, names, arr) {
        this.seedcode = guids
        this.seedname = names
        this.filltemplate = arr[0].attributes['filltemplate']
        this.openiFrame('');
      },
      checkTable(row) {
        this.seedcode = row.seedcode
        this.seedname = row.seedname
        this.filltemplate = row.filltemplate
        this.openiFrame('');
      },
      cangKuGoodsUpdate(){
        this.btnupdatevisible=true;
        this.openiFrame('&post=1&ordermerge=0');//多个退货单
      },
      cangKuGoodsUpdateMerge(){
        this.btnupdatevisible=true;
        this.openiFrame('&post=1&ordermerge=1');//合并一个退货单
      },
      openiFrame(urlend) {
        if (!this.customerserial) {
          this.$message({
            message: '请先选择客户！',
            type: 'warning',
          })
          return;
        }

        this.showframe = true;
        var writeorder = null;
        if (this.openURL == 'HsTuiHuoXianPianApp') {
          this.openURL = "HsTuiHuoXianPianAppch";
        } else {
          this.openURL = "HsTuiHuoXianPianApp";
        }

        writeorder = window.open(window.location.origin + "/#/app/" + this.openURL + "?sename=" + this.seedname + "&seedcode=" + this.seedcode.replace(/\+/g, "%2B").replace(/=/g, "%3D") + "&filltemplate=" + this.filltemplate + urlend, 'writeorder', "")

        if (writeorder && writeorder.open && !writeorder.closed) {
          writeorder.moveTo(-4, -4);
          writeorder.resizeTo(screen.availWidth + 8, screen.availHeight + 8);
        }
      },
      bindData() {
        this.$refs.treeSeed.bindData(() => {
          return getGoodsTree({filltemplates: '10;20;30'})
        })
      },
      //客户地址
      clearcustomerserial() {
        this.customerserial='';
        localStorage.setItem('hpweb_token', ''); //兼容vue端的相关页面
        localStorage.setItem('keFTtoken', ''); //token
        localStorage.setItem('keFuInfoModel', ''); //用户信息
        this.myToken = '';//客户已清空，解除记录的 token
        this.setShopping();
      },
      select(customerserial, customername, row) {
        this.deliveryaddress = row.deliveryaddress
        this.elinkman = row.linkman
        this.elinkmantel = row.linkmantel
        this.deptname = row.deptname
        this.customerserial = row.customerserial
        this.setShopping();
        var initCangKu=row.servedserial;
        if(this.jxcstoreData.length>0) {
          this.cangkucode = this.jxcstoreData[0].cangkucode;
          if(this.fengongscangku) {
            for (let i in this.jxcstoreData) {
              if (this.jxcstoreData[i].independentserial == initCangKu) {
                this.cangkucode = this.jxcstoreData[i].cangkucode;
                break;
              }
            }
          }
          this.changeCangKu();
        }
        //客户信息
        simulationLogin({loginName: this.loginName, customerserial: this.customerserial}).then(response => {
          if (response.data.code == 0) {
            this.jxcstoreData.forEach(o => {
              if (o.cangkucode == this.cangkucode) {
                this.cangkuname = o.cangkuname
              }
            })
            localStorage.setItem('hpweb_token', response.data.token); //兼容vue端的相关页面
            localStorage.setItem('keFTtoken', response.data.token); //token
            localStorage.setItem('keFuInfoModel', JSON.stringify(response.data.obj)); //用户信息
            localStorage.setItem('domain', window.location.host);
            localStorage.setItem('deliveryaddress', this.deliveryaddress);
            localStorage.setItem('elinkman', this.elinkman);
            localStorage.setItem('elinkmantel', this.elinkmantel);
            localStorage.setItem('cangkucode', this.cangkucode);
            localStorage.setItem('cangkuname', this.cangkuname);
            localStorage.setItem('roletype', this.roletype);
            localStorage.setItem('settingmenthod', row.settingmenthod);
            //记录本次选中客户的 token：其他窗口选了别的客户会覆盖全局 localStorage，
            //切回本窗口时一旦发现 token 不一致就关闭当前开单窗口，避免串客户退货
            this.myToken = response.data.token;

            //扫光度码退货模式：直接显示扫码组件，跳过商品选择
            if (this.scanmode) {
              localStorage.setItem('cangkucode', this.cangkucode);
              localStorage.setItem('cangkuname', this.cangkuname);
              this.showframe = true;
              //同步客户信息到扫码退货组件
              if (this.$refs.HsScanlensReturnComp) {
                this.$refs.HsScanlensReturnComp.customerserial = this.customerserial;
                this.$refs.HsScanlensReturnComp.customername = this.deptname;
              }
            }

          } else {
            this.$message({
              type: 'warning',
              duration: 1500,
              message: response.data.msg
            });
          }
        })
      },
      //【多窗口防串客户】每 1 秒检测一次全局 token：若已被其他页面改写（选了别的客户），
      //直接关闭当前开单窗口，避免客服继续用错误的客户退货
      startSessionCheck() {
        this.stopSessionCheck();
        var self = this;
        var check = function () {
          if (!self.dialogFormVisible) {//对话框已关闭，停止检测
            self.sessionCheckTimer = null;
            return;
          }
          if (self.myToken && localStorage.getItem('hpweb_token') !== self.myToken) {
            self.$message({
              type: 'warning',
              duration: 3000,
              message: '检测到客户已在其他页面切换，当前开单窗口已关闭，请重新选择客户'
            });
            self.dialogFormVisible = false;
            self.sessionCheckTimer = null;
            return;
          }
          self.sessionCheckTimer = setTimeout(check, 1000);
        };
        this.sessionCheckTimer = setTimeout(check, 1000);
      },
      stopSessionCheck() {
        if (this.sessionCheckTimer) {
          clearTimeout(this.sessionCheckTimer);
          this.sessionCheckTimer = null;
        }
      },
      onDialogClose() {
        this.stopSessionCheck();
        this.afterCloseDialog();
      },
      showdailog(groupguid) {
        this.$refs.HsCstagreementList.bindGrid(groupguid)
      },
      add() {
        this.$refs.DataContactEdit.initForm()
        this.OpenDialog()
      },
      changeCangKu() {
        localStorage.setItem('cangkucode', this.cangkucode);
        this.jxcstoreData.forEach(o => {
          if (o.cangkucode == this.cangkucode) {
            this.cangkuname = o.cangkuname
          }
        })
        localStorage.setItem('cangkuname', this.cangkuname);
        //扫码退货模式：同步更新 HsScanlensReturn 的仓库信息
        if (this.scanmode && this.$refs.HsScanlensReturnComp) {
          this.$refs.HsScanlensReturnComp.cangkucode = this.cangkucode;
          this.$refs.HsScanlensReturnComp.cangkuname = this.cangkuname;
        }
        try {
          window.writeorder.window.refreshErWeiTable()
        } catch (ee) {
        }
      },
      OpenDialog() {
        this.$refs.DataContactEdit.show()
      },
      show(unitgroup, title, roletype, scantype) {
        if (this.$refs.autocustomer) {
          this.$refs.autocustomer.clearContent();
        }

        //扫光度码退货模式
        this.scanmode = (scantype === 'scan');

        if (!this.scanmode && this.pingpaiLens.length == 0) {
          listLens().then(response => {
            for (let i in response.data.obj) {
              var o = response.data.obj[i]
              this.pingpaiLens.push({
                categorycode: o.categorycode,
                categoryname: o.categoryname,
                type: (i == 0 ? 'danger' : 'info')
              })
            }
            this.selectLens(this.pingpaiLens[0].categorycode);
          })
        }
        this.customerserial = ''
        this.showframe = false
        this.seedname = ''
        this.searchdata = ''//选中的门店
        this.deliveryaddress = ''//收货地址
        this.restaurants = []
        this.pinyinData = []
        this.coupon = ''
        this.province = ''//省
        this.city = ''//市
        this.county = ''//县
        this.couponServedserial = ''//独立核算
        this.roletype = ''
        this.logisticstracknum = ''
        this.tracknum = ''
        this.myToken = ''//清空上次记录的 token，选中客户后重新记录
        this.startSessionCheck();//开始每秒检测全局 token 是否被其他页面改写
        localStorage.setItem('tracknum', "");
        localStorage.setItem('logisticstracknum', "");
        if (unitgroup) {
          this.myunitgroup = unitgroup
        }

        this.mytitle = this.scanmode ? '扫光度码退货' : '退货单'

        if (roletype) {
          this.roletype = roletype
        }
        this.dialogFormVisible = true
        if (this.storeInfo) {
          this.coupon = this.storeInfo.coupon
          this.province = this.storeInfo.province//省
          this.city = this.storeInfo.city//市
          this.county = this.storeInfo.county//县
          this.couponServedserial = this.storeInfo.independentserial//独立核算
        }

        if (this.$refs.autocustomer)
          this.$refs.autocustomer.init();
        this.setShopping();
        this.cusandptbyind();
      },
      cusandptbyind() {
        //根据登录人过滤仓库
        cusandptbyind({}).then(response => {
          this.jxcstoreData = response.data.obj
          //默认仓库
          if (this.userInfoModel.cangku) {
            let temp1 = this.userInfoModel.cangku.split(";")
            biaoji:
              for (let i in temp1) {
                for (let j in  this.jxcstoreData) {
                  if (temp1[i] == this.jxcstoreData[j].cangkucode) {
                    this.cangkucode = temp1[i]
                    break biaoji;
                  }
                }
              }

          } else {
            this.cangkucode = this.jxcstoreData[0].cangkucode
          }
        })

      },
      setItems(item,newItem) {
        for (let i in newItem) {
          var hasV = false;
          for (let j in item) {
            if (newItem[i] == item[j]) {
              hasV = true;
              break;
            }
          }
          if (!hasV&&newItem[i]) {
            item.push(newItem[i]);
          }
        }
        return item;
      },
      selectQuery(item,o) {
        item.value = o;
        this.showTable();
      },
      showTable() {
        var index = 0;
        for (let i in this.goodsLens) {
          var data = this.goodsLens[i]
          data.isshow = false;
          if (index > 110)
            continue;

          if (!this.form.category || data.categorycode == this.form.category) {
            data.isshow = true;
          }
          if (data.isshow) {
            for (let j in this.queryproperty) {
              if (this.queryproperty[j].value) {
                if (!data.queryproperty.includes('{"name":"'+this.queryproperty[j].name+'","item":"'+this.queryproperty[j].value+'"}')) {
                  data.isshow=false;
                  break;
                }
              }
            }
          }
          if (data.isshow)
            index++;
        }
      },
      //扫码退货成功后，由 HsScanlensReturn 通过 window.parent 调用
      handleScanReturnSuccess(erpserial) {
        this.showframe = false;
        this.dialogFormVisible = false;
        this.$emit("bindGrid");
      },
      selectLens(categorycode) {
        this.form.code=''
        this.form.name=''
        this.form.category=''
        for (let i in this.pingpaiLens) {
          if (this.pingpaiLens[i].categorycode == categorycode)
            this.pingpaiLens[i].type = 'danger'
          else
            this.pingpaiLens[i].type = 'info'
        }
        this.xilieLens=[]
        this.goodsLens=[]
        this.queryproperty=[]

        //分类、商品
        categoryList({categorycode: categorycode}).then(response => {
          this.xilieLens = response.data.obj.rows;
          for(let i in this.xilieLens) {
            if (this.xilieLens[i].queryproperty) {
              var qp = JSON.parse(this.xilieLens[i].queryproperty);
              for (let j in qp) {
                var hasValue = false;
                for (let hset in this.queryproperty) {
                  if (this.queryproperty[hset].name == qp[j].name) {//参数已存在
                    hasValue = true;
                    this.queryproperty[hset].items = this.setItems(this.queryproperty[hset].items, qp[j].item.split(';'));
                    break;
                  }
                }

                if (!hasValue&&qp[j].item) {
                  this.queryproperty.push({
                    name: qp[j].name,
                    value: '',
                    items: this.setItems([], qp[j].item.split(';'))
                  })
                }
              }
            }
          }
        })

        getListfixcilumn({
          searchdata: '',
          columns:'SeedCode,seedname,QueryProperty,CategoryCode,filltemplate',
          categorycode: categorycode,
          enabled:1
        }).then(response => {
          this.goodsLens = response.data.obj.rows
          this.showTable();
        }).catch((error) => {
          console.log(error)
        })
      },
    },
    beforeDestroy() {
      this.stopSessionCheck();
      if (window.handleScanReturnSuccess) {
        delete window.handleScanReturnSuccess;
      }
    },
    mounted() {
      this.userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"))
      //将退货成功回调挂到 window，供 HsScanlensReturn 通过 window.parent 调用
      window.handleScanReturnSuccess = this.handleScanReturnSuccess.bind(this);
      checkModuleRight({name: 'fengongscangku'}).then(reponse => {
        this.fengongscangku = reponse.data.code == 0;
      });
    },
    components: {
      HsCstagreementList,
      HsScanlensReturn,
    }

  }


</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  /*.el-table td, .el-table div, .el-table .cell {*/
  /*line-height: 23px;*/
  /*padding: 0px;*/
  /*color: red;*/
  /*}*/

  .name {
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .addr {
    font-size: 12px;
    color: #b4b4b4;
  }


</style>




// WEBPACK FOOTER //
// src/components/testorder/cstagreement/WriteReturnOrder.vue